/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchProcessing extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      message: this.props.message || "Processing..."
    }
  }

  render() {
    var searching;
    if (this.props.searching === true) {
      searching = (
        <div className="admin--search-processing">
          <div className="processing--message">{this.state.message}</div>
        </div>
      );
    } else {
      searching = null;
    }
    return <div>{searching}</div>;
  }
}

export default AdminSearchProcessing;
